/**
 * Approximate geographic centroids for the 36 states + FCT, used by the
 * NationalMap page to drop a marker per state. Values are accurate to roughly
 * one decimal degree (~10 km), which is more than enough for an overview pin.
 *
 * Sources: Wikipedia "List of Nigerian states by population" + state articles.
 * Names match the casing used by service-franchise's `byState[].state` field.
 */
export const STATE_CENTROIDS: Readonly<Record<string, { lat: number; lng: number }>> = {
  Abia: { lat: 5.5321, lng: 7.486 },
  Adamawa: { lat: 9.3265, lng: 12.3984 },
  'Akwa Ibom': { lat: 5.0066, lng: 7.8506 },
  Anambra: { lat: 6.221, lng: 6.9376 },
  Bauchi: { lat: 10.7783, lng: 9.999 },
  Bayelsa: { lat: 4.7719, lng: 6.0699 },
  Benue: { lat: 7.3369, lng: 8.7404 },
  Borno: { lat: 11.8846, lng: 13.152 },
  'Cross River': { lat: 5.8702, lng: 8.5988 },
  Delta: { lat: 5.7041, lng: 5.9339 },
  Ebonyi: { lat: 6.2649, lng: 8.0137 },
  Edo: { lat: 6.634, lng: 5.9305 },
  Ekiti: { lat: 7.7193, lng: 5.311 },
  Enugu: { lat: 6.5244, lng: 7.5106 },
  FCT: { lat: 9.0765, lng: 7.3986 },
  Gombe: { lat: 10.2904, lng: 11.1722 },
  Imo: { lat: 5.4956, lng: 7.0257 },
  Jigawa: { lat: 12.228, lng: 9.5615 },
  Kaduna: { lat: 10.5222, lng: 7.4383 },
  Kano: { lat: 12.0022, lng: 8.592 },
  Katsina: { lat: 12.9908, lng: 7.6018 },
  Kebbi: { lat: 12.4504, lng: 4.1975 },
  Kogi: { lat: 7.7337, lng: 6.6906 },
  Kwara: { lat: 8.4799, lng: 4.5418 },
  Lagos: { lat: 6.5244, lng: 3.3792 },
  Nasarawa: { lat: 8.499, lng: 8.2014 },
  Niger: { lat: 9.6177, lng: 6.5569 },
  Ogun: { lat: 7.1607, lng: 3.3475 },
  Ondo: { lat: 7.1, lng: 5.05 },
  Osun: { lat: 7.5629, lng: 4.52 },
  Oyo: { lat: 7.85, lng: 3.93 },
  Plateau: { lat: 9.2182, lng: 9.5179 },
  Rivers: { lat: 4.8156, lng: 7.0498 },
  Sokoto: { lat: 13.0059, lng: 5.2476 },
  Taraba: { lat: 8.8932, lng: 11.3604 },
  Yobe: { lat: 12.2939, lng: 11.4391 },
  Zamfara: { lat: 12.1222, lng: 6.2236 },
};

/**
 * Geographic centre of Nigeria — used as the default map centre when no
 * single state is the focus.
 */
export const NIGERIA_CENTER = { lat: 9.082, lng: 8.6753 } as const;
